import Avatar from 'boring-avatars';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UserAvatarProfile = props => {
  return /*#__PURE__*/_jsx(Avatar, {
    ...props,
    variant: "beam",
    colors: ['#FC9595', '#FFCFA8', '#FFEEA7', '#9AE3AF', '#7BD7EC', '#A387F7', '#FFB8BA']
  });
};
export default UserAvatarProfile;